import React, { useEffect, useMemo } from 'react'
import { Col, Form, Row } from 'antd'
import { map, toString } from 'lodash'
import PropTypes from 'prop-types'

import { FormButtons, FormSelect } from '../../../common/components/sections'
import {
  StyledPageHeader,
  StyledPageTitle,
} from '../../../common/components/styled'
import { PAGINATION } from '../../../common/constants'
import { useFormDirty } from '../../../common/hooks'

import { userSettingsFormInitialValues } from './initial-values'

const UserSettingsForm = ({ settings, onSubmit }) => {
  const [form] = Form.useForm()

  const initialValues = useMemo(
    () => userSettingsFormInitialValues(settings),
    [settings],
  )

  const pageSizeOptions = useMemo(
    () =>
      map(PAGINATION.DEFAULT_PAGINATION_SIZE_OPTIONS, pageSize => ({
        value: toString(pageSize),
        label: toString(pageSize),
      })),
    [],
  )

  const { isDirty, setToDirty, resetForm } = useFormDirty(form)

  useEffect(() => {
    resetForm()
  }, [settings?.pageSize, resetForm])

  return (
    <Form
      form={form}
      initialValues={initialValues}
      name="userSettings"
      onFinish={onSubmit}
      autoComplete="off"
      onFieldsChange={setToDirty}
    >
      <StyledPageHeader sticky>
        <StyledPageTitle>Settings</StyledPageTitle>
        <FormButtons
          permissions={[]}
          isDisabled={!isDirty}
          onReset={resetForm}
        />
      </StyledPageHeader>
      <Row gutter={[16]}>
        <Col span={5}>
          <FormSelect
            name="pageSize"
            labelAbove
            label="Default Page Size"
            options={pageSizeOptions}
            placeholder="Select default page size..."
          />
        </Col>
      </Row>
    </Form>
  )
}

UserSettingsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  settings: PropTypes.object,
}

UserSettingsForm.defaultProps = {
  settings: {},
}

export default UserSettingsForm
